export default {
    select: "Sélectionnez l'adresse de livraison",
    shippingRulesTip: "Vous devez suivre vos règles locales pour l'expédition"
}